import { render } from "./SiteFooter.vue?vue&type=template&id=75f1086c&scoped=true"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=75f1086c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f1086c"]])

export default __exports__